import { Analytics } from './tracker'
export * from './types'
export { Analytics }

// Instância global opcional para build IIFE (window.Analytics)
declare global {
  interface Window { Analytics?: any }
}
if (typeof window !== 'undefined') {
  ;(window as any).Analytics = Analytics
}
